<template>
  <div>
    <section v-if="loadedComponent">
      <!-- Main Content -->
      <div class="main-content">
        <div class="row mt-3">
          <!-- Client -->
          <div class="col-lg-4 col-md-6">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-12">
                    <div
                      class="client-name more-text"
                      style="text-transform: uppercase; color: #08b9b3"
                    >
                      {{ demand.order_type.type_name }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row" v-if="check_step == 1">
                  <div class="col-12">
                    <div class="title-card">Dados do Cliente</div>
                    <div class="info-client more-text">
                      <!-- <i class="fas fa-map-marker-alt"></i> -->
                      {{ demand.customer.name }}
                    </div>
                    <div class="info-client more-text">
                      <!-- <i class="fas fa-map-marker-alt"></i> -->
                      {{ demand.customer.address }} -
                      {{ demand.customer.city }} - {{ demand.customer.state }}
                    </div>
                    <div class="info-client no-icon"></div>
                    <div
                      class="info-client"
                      style="margin-top: 5px"
                      v-if="demand.customer.telephone"
                    >
                      <!-- <i class="fas fa-mobile-alt"></i> -->
                      {{ demand.customer.telephone }}
                    </div>
                  </div>
                </div>
                <div
                  class="row"
                  v-if="check_step == 1"
                  style="margin-top: 15px"
                >
                  <div class="col-12">
                    <div class="title-card">Dados do Atendimento</div>
                    <div class="info-client more-text">
                      <div class="info-client more-text">
                        <span style="text-align: left"
                          >Descrição: {{ demand.order_type.type_name }}</span
                        >
                      </div>
                      <!-- <i class="fas fa-map-marker-alt"></i> -->
                      <span style="text-align: left">{{ demand.date }}</span>
                      às
                      <span style="text-align: right">{{ demand.hour }}</span>
                    </div>
                  </div>
                </div>
                <div
                  class="row"
                  v-if="demand.status == 4 && check_step == 1"
                  style="margin-top: 25px"
                >
                  <div class="col-12">
                    <div
                      class="alert alert-secondary"
                      style="font-size: 14px"
                      role="alert"
                    >
                      Execute cada tarefa da lista com atenção, marque os itens
                      e siga para o próximo passo.
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="card-subtitle">Lista de tarefas:</div>
                    <div
                      class="custom-control custom-checkbox"
                      v-for="check in demand.order_type.checklist"
                      :key="check.id"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        v-model="check.value"
                        :value="check.id"
                        :id="'customCheck' + check.id"
                      />
                      <label
                        class="custom-control-label"
                        :for="'customCheck' + check.id"
                        >{{ check.title }}</label
                      >
                    </div>
                  </div>
                </div>
                <template v-if="check_step == 2">
                  <div
                    class="row"
                    v-if="demand.status == 4"
                    style="padding-top: 15px"
                  >
                    <div class="col-12">
                      <div
                        class="alert alert-secondary"
                        style="font-size: 14px"
                        role="alert"
                      >
                        Agora, precisamos que você tire algumas fotos do seu
                        atendimento, clique sobre a câmera e lembre-se de tirar
                        as fotos com o celular na vertical!
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="card-subtitle">Fotos da execução:</div>
                    </div>
                    <div class="col-6" style="padding: 15px">
                      <!-- <input
                      name="photo1"
                      id="photo1"
                      type="file"
                      style="display: none"
                      @change="uploadPhoto1"
                    /> -->
                      <!-- <input
                      type="file"
                      style="display: none"
                      accept="image/*"
                      capture="camera"
                      @change="uploadPhoto1"
                      id="photo1"
                    /> -->

                      <image-uploader
                        :maxWidth="800"
                        :preview="false"
                        :capture="true"
                        :debug="1"
                        doNotResize="gif"
                        :autoRotate="false"
                        outputFormat="verbose"
                        style="display: none"
                        id="photo1"
                        @change.native="loadPhoto1 = true"
                        @input="uploadPhoto1"
                      ></image-uploader>
                      <button
                        v-if="loadPhoto1 && !previewPhoto1"
                        class="btn btn-block btn-addimg"
                      >
                        <i
                          class="fas fa-circle-notch fa-spin"
                          style="font-size: 30px"
                        ></i>
                      </button>
                      <img
                        v-else-if="previewPhoto1"
                        :src="previewPhoto1"
                        class="btn btn-block no-height"
                        onclick="document.getElementById('photo1').click();"
                      />
                      <button
                        v-else
                        class="btn btn-block btn-addimg"
                        onclick="document.getElementById('photo1').click();"
                      >
                        <i class="fas fa-camera" style="font-size: 30px"></i>
                      </button>
                    </div>
                    <div class="col-6" style="padding: 15px">
                      <image-uploader
                        :maxWidth="800"
                        :preview="false"
                        :capture="true"
                        :debug="1"
                        doNotResize="gif"
                        :autoRotate="false"
                        outputFormat="verbose"
                        style="display: none"
                        id="photo2"
                        @change.native="loadPhoto2 = true"
                        @input="uploadPhoto2"
                      ></image-uploader>
                      <button
                        v-if="loadPhoto2 && !previewPhoto2"
                        class="btn btn-block btn-addimg"
                      >
                        <i
                          class="fas fa-circle-notch fa-spin"
                          style="font-size: 30px"
                        ></i>
                      </button>
                      <img
                        v-else-if="previewPhoto2"
                        :src="previewPhoto2"
                        class="btn btn-block no-height"
                        onclick="document.getElementById('photo2').click();"
                      />
                      <button
                        v-else
                        class="btn btn-block btn-addimg"
                        onclick="document.getElementById('photo2').click();"
                      >
                        <i class="fas fa-camera" style="font-size: 30px"></i>
                      </button>
                    </div>
                    <div class="col-6" style="padding: 15px">
                      <image-uploader
                        :maxWidth="800"
                        :preview="false"
                        :capture="true"
                        :debug="1"
                        doNotResize="gif"
                        :autoRotate="false"
                        outputFormat="verbose"
                        style="display: none"
                        id="photo3"
                        @change.native="loadPhoto3 = true"
                        @input="uploadPhoto3"
                      ></image-uploader>
                      <button
                        v-if="loadPhoto3 && !previewPhoto3"
                        class="btn btn-block btn-addimg"
                      >
                        <i
                          class="fas fa-circle-notch fa-spin"
                          style="font-size: 30px"
                        ></i>
                      </button>
                      <img
                        v-else-if="previewPhoto3"
                        :src="previewPhoto3"
                        class="btn btn-block btn-addimg no-height"
                        onclick="document.getElementById('photo3').click();"
                      />
                      <button
                        v-else
                        class="btn btn-block btn-addimg"
                        onclick="document.getElementById('photo3').click();"
                      >
                        <i class="fas fa-camera" style="font-size: 30px"></i>
                      </button>
                    </div>
                    <div class="col-6" style="padding: 15px">
                      <image-uploader
                        :maxWidth="800"
                        :preview="false"
                        :capture="true"
                        :debug="1"
                        doNotResize="gif"
                        :autoRotate="false"
                        outputFormat="verbose"
                        style="display: none"
                        id="photo4"
                        @change.native="loadPhoto4 = true"
                        @change="uploadPhoto4"
                      ></image-uploader>
                      <button
                        v-if="loadPhoto4 && !previewPhoto4"
                        class="btn btn-block btn-addimg"
                      >
                        <i
                          class="fas fa-circle-notch fa-spin"
                          style="font-size: 30px"
                        ></i>
                      </button>
                      <img
                        v-else-if="previewPhoto4"
                        :src="previewPhoto4"
                        class="btn btn-block btn-addimg no-height"
                        onclick="document.getElementById('photo4').click();"
                      />
                      <button
                        v-else
                        class="btn btn-block btn-addimg"
                        onclick="document.getElementById('photo4').click();"
                      >
                        <i class="fas fa-camera" style="font-size: 30px"></i>
                      </button>
                    </div>
                  </div>
                </template>

                <template v-if="check_step == 3">
                  <div class="row" v-if="demand.status == 4">
                    <div class="col-12">
                      <div
                        class="alert alert-secondary"
                        style="font-size: 14px"
                        role="alert"
                      >
                        Agora, dê uma nota de 1 a 5 para o atendimento por parte
                        do cliente, se você tiver alguma observação sobre o
                        cliente ou o atendimento, pode escrever no campo "Notas
                        adicionais"
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="card-subtitle">Avalie o Cliente:</div>
                      <form class="rating">
                        <label>
                          <input
                            type="radio"
                            name="stars"
                            v-model="demand.avaliation"
                            value="1"
                          />
                          <span class="icon">★</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="stars"
                            v-model="demand.avaliation"
                            value="2"
                          />
                          <span class="icon">★</span>
                          <span class="icon">★</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="stars"
                            v-model="demand.avaliation"
                            value="3"
                          />
                          <span class="icon">★</span>
                          <span class="icon">★</span>
                          <span class="icon">★</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="stars"
                            v-model="demand.avaliation"
                            value="4"
                          />
                          <span class="icon">★</span>
                          <span class="icon">★</span>
                          <span class="icon">★</span>
                          <span class="icon">★</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="stars"
                            v-model="demand.avaliation"
                            value="5"
                          />
                          <span class="icon">★</span>
                          <span class="icon">★</span>
                          <span class="icon">★</span>
                          <span class="icon">★</span>
                          <span class="icon">★</span>
                        </label>
                      </form>
                    </div>
                  </div>
                  <div class="row" v-if="demand.status == 4">
                    <div class="col-12">
                      <div class="card-subtitle">Notas adicionais:</div>
                      <textarea
                        rows="5"
                        class="form-control"
                        v-model="demand.observation"
                      ></textarea>
                    </div>
                  </div>
                </template>
                <div
                  class="row"
                  style="
                    margin-top: 40px;
                    margin-left: 10px;
                    margin-right: 10px;
                  "
                >
                  <div class="col-12" v-if="demand.status == 2">
                    <button class="btn btn-main" @click="checkin">
                      Check-in
                    </button>
                  </div>
                  <div
                    class="col-6"
                    v-if="demand.status == 4 && check_step <= 3"
                  >
                    <button class="btn btn-main" @click="prevStep">
                      <i class="fas fa-arrow-left"></i> Voltar
                    </button>
                  </div>
                  <div
                    class="col-6"
                    v-if="demand.status == 4 && check_step == 3"
                  >
                    <button class="btn btn-main" @click="checkout">
                      Check-out
                    </button>
                  </div>
                  <div
                    class="col-6"
                    v-if="demand.status == 4 && check_step < 3"
                  >
                    <button class="btn btn-main" @click="nextStep">
                      Avançar <i class="fas fa-arrow-right"></i>
                    </button>
                  </div>
                  <div class="col-12" v-if="demand.status == 1">
                    <button class="btn btn-main" @click="confirm">
                      Confirmar Visita
                    </button>
                  </div>
                  <div class="col-12">
                    <button
                      class="btn btn-reject"
                      v-if="demand.status < 5"
                      @click="recuse"
                    >
                      Reagendar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Timeline -->

      <!-- Main Content -->
      <div class="main-content" v-if="demand.status == 5">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">Timeline do Atendimento</div>
              <div class="row" style="margin: 10px" v-if="loaded">
                <div class="col-md-12 col-lg-12">
                  <div id="tracking-pre"></div>
                  <div id="tracking">
                    <div class="tracking-list">
                      <div class="tracking-item" v-if="demand.finished_at">
                        <div class="tracking-icon status-intransit">
                          <svg
                            class="svg-inline--fa fa-circle fa-w-16"
                            aria-hidden="true"
                            data-prefix="fas"
                            style="color: #08b9b3"
                            data-icon="circle"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            data-fa-i2svg=""
                          >
                            <path
                              fill="currentColor"
                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                            ></path>
                          </svg>
                          <!-- <i class="fas fa-circle"></i> -->
                        </div>
                        <div class="tracking-date">
                          {{ demand.checkout_date
                          }}<span> às {{ demand.checkout_hour }}</span>
                        </div>
                        <div class="tracking-content">
                          Check-out realizado
                          <span
                            >realizado por {{ demand.assignee.name }}, nas
                            coordenadas latitude:
                            {{ demand.latitude_checkout }} e longitude:
                            {{ demand.longitude_checkout }}</span
                          >
                          <div style="margin-top: 10px">
                            <button
                              class="btn btn-add"
                              @click="openLightbox(demand)"
                            >
                              Visualizar Fotos
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="tracking-item" v-if="demand.checkin_at">
                        <div class="tracking-icon status-intransit">
                          <svg
                            class="svg-inline--fa fa-circle fa-w-16"
                            aria-hidden="true"
                            data-prefix="fas"
                            style="color: #08b9b3"
                            data-icon="circle"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            data-fa-i2svg=""
                          >
                            <path
                              fill="currentColor"
                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                            ></path>
                          </svg>
                          <!-- <i class="fas fa-circle"></i> -->
                        </div>
                        <div class="tracking-date">
                          {{ demand.checkin_date
                          }}<span> às {{ demand.checkin_hour }}</span>
                        </div>
                        <div class="tracking-content">
                          Check-in realizado
                          <span
                            >realizado por {{ demand.assignee.name }}, nas
                            coordenadas latitude:
                            {{ demand.latitude_checkin }} e longitude:
                            {{ demand.longitude_checkin }}</span
                          >
                        </div>
                      </div>

                      <div class="tracking-item" v-if="demand.confirmed_at">
                        <div class="tracking-icon status-intransit">
                          <svg
                            class="svg-inline--fa fa-circle fa-w-16"
                            aria-hidden="true"
                            data-prefix="fas"
                            style="color: #08b9b3"
                            data-icon="circle"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            data-fa-i2svg=""
                          >
                            <path
                              fill="currentColor"
                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                            ></path>
                          </svg>
                          <!-- <i class="fas fa-circle"></i> -->
                        </div>
                        <div class="tracking-date">
                          {{ demand.confirmed_date
                          }}<span> às {{ demand.confirmed_hour }}</span>
                        </div>
                        <div class="tracking-content">
                          Visita confirmada
                          <span>confirmada por {{ demand.assignee.name }}</span>
                        </div>
                      </div>

                      <div class="tracking-item" v-if="demand.assignee_at">
                        <div class="tracking-icon status-intransit">
                          <svg
                            class="svg-inline--fa fa-circle fa-w-16"
                            aria-hidden="true"
                            data-prefix="fas"
                            style="color: #08b9b3"
                            data-icon="circle"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            data-fa-i2svg=""
                          >
                            <path
                              fill="currentColor"
                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                            ></path>
                          </svg>
                          <!-- <i class="fas fa-circle"></i> -->
                        </div>
                        <div class="tracking-date">
                          {{ demand.assignee_date
                          }}<span> às {{ demand.assignee_hour }}</span>
                        </div>
                        <div class="tracking-content">
                          Colaborador atribuído: {{ demand.assignee.name }}
                          <span>atribuído por {{ demand.technical.name }}</span>
                        </div>
                      </div>

                      <div class="tracking-item">
                        <div class="tracking-icon status-intransit">
                          <svg
                            class="svg-inline--fa fa-circle fa-w-16"
                            aria-hidden="true"
                            data-prefix="fas"
                            style="color: #08b9b3"
                            data-icon="circle"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            data-fa-i2svg=""
                          >
                            <path
                              fill="currentColor"
                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                            ></path>
                          </svg>
                          <!-- <i class="fas fa-circle"></i> -->
                        </div>
                        <div class="tracking-date">
                          {{ demand.created_date
                          }}<span> às {{ demand.created_hour }}</span>
                        </div>
                        <div class="tracking-content">
                          Atendimento Criado
                          <span
                            >criado por {{ demand.technical.name }}, solicitação
                            Fluig: {{ demand.solicitation_id }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template>
        <vue-easy-lightbox
          :visible="visible"
          :imgs="imgs"
          @hide="handleHide"
        ></vue-easy-lightbox>
      </template>
    </section>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </div>
</template>

<script>
import CtkDateTimePicker from "vue-ctk-date-time-picker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      check_step: 1,
      index: 0,
      imgs: "", // Img Url , string or Array
      visible: false,
      demand: {
        order_type: {},
        customer: {},
        avaliation: 0,
        observation: "",
      },

      srcCheckin: "",
      srcCheckout: "",
      order_type: {},
      location: {},
      image: "",
      previewPhoto1: "",
      loadPhoto1: false,
      previewPhoto2: "",
      loadPhoto2: false,
      previewPhoto3: "",
      loadPhoto3: false,
      previewPhoto4: "",
      loadPhoto4: false,
      isLoading: true,
      fullPage: true,
      hasImage: "",
      name: "",
      loaded: false,
      loadedComponent: false,
    };
  },
  computed: {},
  methods: {
    prevStep() {
      this.check_step = Number(this.check_step) - Number(1);
    },
    nextStep() {
      this.check_step = Number(this.check_step) + Number(1);
    },
    openLightbox(data) {
      this.imgs = [
        data.photo1,
        data.photo2,
        data.photo3,
        data.photo4,
        data.photo5,
        data.photo6,
      ];
      this.index = 1; // index of imgList
      this.show();
    },
    show() {
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    bringData: function () {
      const self = this;
      const api =
        self.$store.state.api +
        "demands/" +
        self.$route.params.id +
        "?with[]=order_type&with[]=customer&with[]=technical&with[]=assignee";

      self.$http
        .get(api)
        .then((response) => {
          self.demand = response.data.data[0];
          self.demand.observation = "";
          self.demand.avaliation = "0";
          self.loadedComponent = true;

          self.loaded = true;

          self.loaded = true;
          self.isLoading = false;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    confirm() {
      const self = this;
      const api = self.$store.state.api + "confirm-demand";

      self.isLoading = true;

      self.$http
        .post(api, self.demand)
        .then((response) => {
          self.isLoading = false;
          this.$router.push("/");
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
          self.isLoading = false;
          this.$router.push("/");
        });
    },
    recuse() {
      const self = this;
      const api = self.$store.state.api + "recuse-demand";

      swal({
        title: "Tem certeza que deseja reagendar a visita?",
        text: "Informe um motivo",
        content: "input",
        // showCancelButton: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-secondary",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
            className: "btn-primary",
          },
        },
      }).then((cancelReason) => {
        self.isLoading = true;
        self.demand.reason = cancelReason;
        self.$http
          .post(api, self.demand)
          .then((response) => {
            self.isLoading = false;
            this.$router.push("/");
          })
          .catch((error) => {
            self.$message("Erro", error.response.data, "error");
            self.isLoading = false;
            this.$router.push("/");
          });
      });
    },
    checkin() {
      const self = this;
      const api = self.$store.state.api + "checkin-demand";

      if (self.location.coords == undefined) {
        self.showPermissionDeniedSwal();
      } else {
        self.demand.latitude_checkin = self.location.coords.latitude;
        self.demand.longitude_checkin = self.location.coords.longitude;

        self.isLoading = true;

        self.$http
          .post(api, self.demand)
          .then((response) => {
            self.isLoading = false;
            this.$router.push("/");
          })
          .catch((error) => {
            self.$message("Erro", error.response.data, "error");
            self.isLoading = false;
            this.$router.push("/");
          });
      }
    },

    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      if (self.previewPhoto1) {
        fd.append("photo1", self.previewPhoto1);
      }

      if (self.previewPhoto2) {
        fd.append("photo2", self.previewPhoto2);
      }

      if (self.previewPhoto3) {
        fd.append("photo3", self.previewPhoto3);
      }

      if (self.previewPhoto4) {
        fd.append("photo4", self.previewPhoto4);
      }

      // let photo3 = document.getElementById("photo3");

      // if (photo3.files[0]) {
      //   fd.append("photo3", photo3.files[0] ? photo3.files[0] : "");
      // }

      // let photo4 = document.getElementById("photo4");

      // if (photo4.files[0]) {
      //   fd.append("photo4", photo4.files[0] ? photo4.files[0] : "");
      // }

      var i = 1;
      self.demand.order_type.checklist.forEach((checklist) => {
        fd.append("checklist[" + i + "][id]", checklist.id);
        fd.append("checklist[" + i + "][title]", checklist.title);
        fd.append("checklist[" + i + "][value]", checklist.value);
        i++;
      });

      if (self.location.coords != undefined) {
        self.demand.latitude_checkout = self.location.coords.latitude;
        self.demand.longitude_checkout = self.location.coords.longitude;

        fd.append("latitude_checkout", self.demand.latitude_checkout);
        fd.append("longitude_checkout", self.demand.longitude_checkout);
      }

      fd.append("observation", self.demand.observation);
      fd.append("avaliation", self.demand.avaliation);
      fd.append("id", self.demand.id);

      return fd;
    },
    checkout() {
      const self = this;
      const api = self.$store.state.api + "checkout-demand";

      if (self.location.coords == undefined) {
        self.showPermissionDeniedSwal();
      } else {
        let fd = self.makeFormData();

        self.isLoading = true;
        self.$http
          .post(api, fd)
          .then((response) => {
            self.isLoading = false;
            this.$router.push("/");
          })
          .catch((error) => {
            self.$message("Erro", error.response.data, "error");
            self.isLoading = false;
          });
      }
    },

    setImage: function (output) {
      this.hasImage = true;
      this.image = output;
    },

    uploadPhoto1(e) {
      this.loadPhoto1 = true;
      this.previewPhoto1 = e.dataUrl;
    },
    uploadPhoto2(e) {
      this.previewPhoto2 = e.dataUrl;
    },
    uploadPhoto3(e) {
      this.previewPhoto3 = e.dataUrl;
    },
    uploadPhoto4(e) {
      this.previewPhoto4 = e.dataUrl;
    },
    showPermissionDeniedSwal() {
      swal({
        title: "Permissão para acessar geolocalização",
        text:
          "Para realizar este processo, você precisa liberar o acesso à geolocalização, siga estes passos para desbloquear: \n\n" +
          "1 - Clique em Configurações\n" +
          "2 - Clique em Configurações do site\n" +
          "3 - Clique em Local\n" +
          "4 - Na lista de bloqueados procure por https://app.flowservices.com.br clique sobre ele e na sequencia clique em Limpar e Redefinir \n" +
          "5 - Tente novamente",
        type: "info",
        closeOnConfirm: true,
      });
    },
  },
  components: { CtkDateTimePicker, Loading },
  props: {},
  mounted: function () {
    this.bringData();

    if (!("geolocation" in navigator)) {
      this.errorStr = "Geolocation não disponível.";
      return;
    }

    this.gettingLocation = true;
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        this.gettingLocation = false;
        this.location = pos;
      },
      (err) => {
        this.gettingLocation = false;
        this.errorStr = err.message;
        // alert(err.message);
      }
    );
  },
};
</script>
<style scoped>
.title {
  color: rgb(37, 37, 37);
  text-transform: uppercase;
  font-size: 18px;
  font-weight: bold;
  margin-top: 25px;
  text-align: center;
}

.sub-title {
  color: rgb(37, 37, 37);
  text-transform: uppercase;
  font-size: 16px;
  font-weight: bold;
  margin-top: 25px;
  text-align: left;
}
.info-client i {
  color: black;
}

.tracking-detail {
  padding: 3rem 0;
}
#tracking {
  margin-bottom: 1rem;
}
[class*="tracking-status-"] p {
  margin: 0;
  font-size: 1.1rem;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
}
[class*="tracking-status-"] {
  padding: 1.6rem 0;
}
.tracking-status-intransit {
  background-color: #65aee0;
}
.tracking-status-outfordelivery {
  background-color: #f5a551;
}
.tracking-status-deliveryoffice {
  background-color: #f7dc6f;
}
.tracking-status-delivered {
  background-color: #4cbb87;
}
.tracking-status-attemptfail {
  background-color: #b789c7;
}
.tracking-status-error,
.tracking-status-exception {
  background-color: #d26759;
}
.tracking-status-expired {
  background-color: #616e7d;
}
.tracking-status-pending {
  background-color: #ccc;
}
.tracking-status-inforeceived {
  background-color: #214977;
}
.tracking-list {
  border: 0px solid #e5e5e5;
}
.tracking-item {
  border-left: 1px solid #e5e5e5;
  position: relative;
  padding: 2rem 1.5rem 0.5rem 2.5rem;
  font-size: 0.9rem;
  margin-left: 3rem;
  min-height: 5rem;
}
.tracking-item:last-child {
  padding-bottom: 4rem;
}
.tracking-item .tracking-date {
  margin-bottom: 0.5rem;
}
.tracking-item .tracking-date span {
  color: #888;
  font-size: 85%;
  padding-left: 0.4rem;
}
.tracking-item .tracking-content {
  padding: 0.5rem 0.8rem;
  background-color: #f4f4f4;
  border-radius: 0.5rem;
}
.tracking-item .tracking-content span {
  display: block;
  color: #888;
  font-size: 85%;
}
.tracking-item .tracking-icon {
  line-height: 2.6rem;
  position: absolute;
  left: -0.9rem;
  width: 1.6rem;
  height: 1.6rem;
  text-align: center;
  border-radius: 50%;
  font-size: 1.1rem;
  background-color: #fff;
  color: #fff;
}
.tracking-item .tracking-icon.status-sponsored {
  background-color: #f68;
}
.tracking-item .tracking-icon.status-delivered {
  background-color: #4cbb87;
}
.tracking-item .tracking-icon.status-outfordelivery {
  background-color: #f5a551;
}
.tracking-item .tracking-icon.status-deliveryoffice {
  background-color: #f7dc6f;
}
.tracking-item .tracking-icon.status-attemptfail {
  background-color: #b789c7;
}
.tracking-item .tracking-icon.status-exception {
  background-color: #d26759;
}
.tracking-item .tracking-icon.status-inforeceived {
  background-color: #214977;
}
.tracking-item .tracking-icon.status-intransit {
  color: #e5e5e5;
  border: 1px solid #e5e5e5;
  font-size: 0.6rem;
}
@media (min-width: 992px) {
  .tracking-item {
    margin-left: 10rem;
  }
  .tracking-item .tracking-date {
    position: absolute;
    left: -10rem;
    width: 7.5rem;
    text-align: right;
  }
  .tracking-item .tracking-date span {
    display: block;
  }
  .tracking-item .tracking-content {
    padding: 0;
    background-color: transparent;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/View.vue